import { c as e } from "react/compiler-runtime";
import { AuthError as t, InteractionStatus as n, LogLevel as r, createStandardPublicClientApplication as i } from "@azure/msal-browser";
import { MsalProvider as a, useMsal as o } from "@azure/msal-react";
import { createContext as s, useEffect as c, useState as l } from "react";
import u from "axios";
import { jsx as d } from "react/jsx-runtime";
//#region src/config/Config.ts
var f = {
	Local: "local",
	Dev: "dev",
	Stg: "stg",
	Prd: "prd"
}, p = (e) => {
	let t = new URL(e).hostname;
	return t === "localhost" || t === "127.0.0.1" ? f.Local : t.startsWith("dev.") ? f.Dev : t.startsWith("stg.") ? f.Stg : f.Prd;
}, m = (e) => e !== f.Prd, h = s({
	getAuthToken: async () => {
		throw Error("getAuthToken not initialized");
	},
	userAccount: {}
}), g = [
	"invalid_grant",
	"interaction_required",
	"no_tokens_found"
], _ = async (e, n, r) => {
	let i = {
		scopes: r,
		account: e
	};
	try {
		if (!e) throw await n.acquireTokenRedirect(i), Error("Redirecting for token acquisition");
		await Promise.resolve();
		let t = await n.acquireTokenSilent(i);
		if (!t.account) throw await n.acquireTokenRedirect(i), Error("Redirecting for token acquisition");
		return t.accessToken;
	} catch (e) {
		throw e instanceof t && g.includes(e.errorCode) ? (await n.logoutRedirect(), Error("Logged out due to authentication error")) : (console.error(e), Error("Failed to acquire token"));
	}
}, v = /* @__PURE__ */ function(e) {
	return e.MsalInitialized = "MsalInitialized", e.AuthRedirectionsComplete = "AuthRedirectionsComplete", e.Ready = "Ready", e;
}(v || {}), y = async (e, t) => {
	try {
		let n = await u.get(`${e}/heartbeat`, { headers: { Authorization: `Bearer ${t}` } });
		if (n.status !== 204) return console.error("Heartbeat failed with status code:", n.status), !1;
	} catch (e) {
		return console.error("Error performing heartbeat:", e), !1;
	}
	return !0;
}, b = (e) => {
	let t = e?.idTokenClaims;
	if (t) return {
		firstName: t?.given_name,
		lastName: t?.family_name,
		fullName: `${t?.given_name} ${t?.family_name}`,
		user: t?.user,
		userType: t?.userType,
		agent: t?.agent,
		agency: t?.agency,
		roles: t?.roles
	};
}, x = (e) => {
	if (!e) throw console.error("Auth app URI is undefined"), Error("Auth app URI is undefined");
	return [`${e}/openid`];
}, S = (t) => {
	let r = e(24), { baseApiUri: i, authAppUri: a } = t;
	if (i == null || a == null) throw console.error("Base API URI or Auth app URI is undefined"), Error("Base API URI or Auth app URI is undefined");
	let [s, u] = l(v.MsalInitialized), { instance: d, accounts: f, inProgress: p } = o(), m = f == null || f.length === 0 ? void 0 : f[0], h;
	r[0] === a ? h = r[1] : (h = x(a), r[0] = a, r[1] = h);
	let g = h, S, T;
	r[2] !== s || r[3] !== p ? (S = () => {
		s === v.MsalInitialized && p === n.None && u(C);
	}, T = [s, p], r[2] = s, r[3] = p, r[4] = S, r[5] = T) : (S = r[4], T = r[5]), c(S, T);
	let E, D;
	r[6] !== m || r[7] !== i || r[8] !== d || r[9] !== s || r[10] !== p || r[11] !== g ? (E = () => {
		if (d && s === v.AuthRedirectionsComplete && p === n.None) {
			if (!i) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
			_(m, d, g).then((e) => {
				if (!e) throw console.error("No auth token available"), Error("No auth token available");
				y(i, e).then((e) => {
					if (!e) throw console.error("Heartbeat failed"), Error("Heartbeat failed");
					u(w);
				});
			});
		}
	}, D = [
		s,
		d,
		m,
		g,
		i,
		p
	], r[6] = m, r[7] = i, r[8] = d, r[9] = s, r[10] = p, r[11] = g, r[12] = E, r[13] = D) : (E = r[12], D = r[13]), c(E, D);
	let O;
	r[14] === m ? O = r[15] : (O = b(m), r[14] = m, r[15] = O);
	let k = O, A;
	r[16] !== m || r[17] !== d || r[18] !== s || r[19] !== g ? (A = s === v.Ready ? () => _(m, d, g) : void 0, r[16] = m, r[17] = d, r[18] = s, r[19] = g, r[20] = A) : A = r[20];
	let j = A, M;
	return r[21] !== j || r[22] !== k ? (M = [k, j], r[21] = j, r[22] = k, r[23] = M) : M = r[23], M;
};
function C(e) {
	return e === v.MsalInitialized ? v.AuthRedirectionsComplete : e;
}
function w(e) {
	return e === v.AuthRedirectionsComplete ? v.Ready : e;
}
//#endregion
//#region src/msal/AuthProvider.tsx
var T = (t) => {
	let n = e(6), { children: r, apiConfig: i } = t, [a, o] = S(i);
	if (!a || !o) return null;
	let s;
	n[0] !== o || n[1] !== a ? (s = {
		getAuthToken: o,
		userAccount: a
	}, n[0] = o, n[1] = a, n[2] = s) : s = n[2];
	let c = s, l;
	return n[3] !== c || n[4] !== r ? (l = /* @__PURE__ */ d(h.Provider, {
		value: c,
		children: r
	}), n[3] = c, n[4] = r, n[5] = l) : l = n[5], l;
}, E = ({ authClientId: e, authInstance: t, authDomain: n, authSignupSigninPolicyId: i, envSigninPrefix: a, authEnableLogs: o }) => {
	if (!e) throw Error("authClientId is not set");
	if (!t) throw Error("authInstance is not set");
	if (!n) throw Error("authDomain is not set");
	if (!i) throw Error("authSignupSigninPolicyId is not set");
	if (!a) throw Error("envSigninPrefix is not set");
	let s = o === "true";
	return {
		auth: {
			clientId: e,
			authority: `https://${t}/${n}/${i}`,
			knownAuthorities: [t],
			redirectUri: a
		},
		cache: { cacheLocation: "sessionStorage" },
		system: { loggerOptions: { loggerCallback: (e, t, n) => {
			if (s && !n) switch (e) {
				case r.Error:
					console.error(t);
					return;
				case r.Info:
					console.info(t);
					return;
				case r.Verbose:
					console.debug(t);
					return;
				case r.Warning:
					console.warn(t);
					return;
				default: return;
			}
		} } }
	};
}, D = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, rolesClaim: r }) => ({
	firstName: "Local",
	lastName: "User",
	fullName: "Local User",
	user: e,
	userType: t,
	agent: e,
	agency: n,
	roles: r?.split(",").map((e) => e.trim()).filter(Boolean)
}), O = (t) => {
	let n = e(7), { children: r, apiConfig: i } = t, a;
	n[0] === i ? a = n[1] : (a = D(i), n[0] = i, n[1] = a);
	let o;
	n[2] === a ? o = n[3] : (o = {
		getAuthToken: j,
		userAccount: a
	}, n[2] = a, n[3] = o);
	let s;
	return n[4] !== r || n[5] !== o ? (s = /* @__PURE__ */ d(h.Provider, {
		value: o,
		children: r
	}), n[4] = r, n[5] = o, n[6] = s) : s = n[6], s;
}, k = (t) => {
	let n = e(9), { children: r, apiConfig: o } = t, [s, u] = l(void 0), f, p;
	if (n[0] === o ? (f = n[1], p = n[2]) : (f = () => {
		i(E(o)).then((e) => {
			u(e);
		});
	}, p = [o], n[0] = o, n[1] = f, n[2] = p), c(f, p), !s) return null;
	let m;
	n[3] !== o || n[4] !== r ? (m = /* @__PURE__ */ d(T, {
		apiConfig: o,
		children: r
	}), n[3] = o, n[4] = r, n[5] = m) : m = n[5];
	let h;
	return n[6] !== s || n[7] !== m ? (h = /* @__PURE__ */ d(a, {
		instance: s,
		children: m
	}), n[6] = s, n[7] = m, n[8] = h) : h = n[8], h;
}, A = (t) => {
	let n = e(6), { children: r, apiConfig: i } = t;
	if (i.devMode && i.userIdClaim && i.userTypeClaim) {
		let e;
		return n[0] !== i || n[1] !== r ? (e = /* @__PURE__ */ d(O, {
			apiConfig: i,
			children: r
		}), n[0] = i, n[1] = r, n[2] = e) : e = n[2], e;
	}
	let a;
	return n[3] !== i || n[4] !== r ? (a = /* @__PURE__ */ d(k, {
		apiConfig: i,
		children: r
	}), n[3] = i, n[4] = r, n[5] = a) : a = n[5], a;
};
async function j() {
	return "local-dev-auth";
}
//#endregion
//#region src/api/AuthorizedApiBase.ts
var M = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, rolesClaim: r }) => {
	let i = {};
	return e !== void 0 && (i["x-claim-userId"] = e), t !== void 0 && (i["x-claim-userType"] = t), n !== void 0 && (i["x-claim-agency"] = n), r !== void 0 && (i["x-claim-roles"] = r), i;
}, N = class {
	getAuthTokenFunction = void 0;
	devHeaders = {};
	constructor() {}
	transformOptions = async (e) => {
		if (!this.getAuthTokenFunction) throw Error("No getAuthTokenFunction has been provided");
		let t = await this.getAuthTokenFunction();
		return e.headers = {
			...e.headers,
			...this.devHeaders,
			Authorization: `Bearer ${t}`
		}, Promise.resolve(e);
	};
	setAuthConfig = (e, t) => {
		this.getAuthTokenFunction = e, this.devHeaders = M(t);
	};
	async transformResult(e, t, n) {
		let r = String(t.headers?.["content-type"] ?? "").toLowerCase(), i = t.data;
		return r.includes("application/json") && typeof i == "object" && i ? i : await Promise.resolve(n(t));
	}
}, P = /* @__PURE__ */ function(e) {
	return e.Director = "director", e.SalesAgent = "salesagent", e.Admin = "admin", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.BusinessManager = "businessmanager", e.AdminManager = "adminmanager", e.MarketingExpert = "marketingexpert", e.ListingsContributor = "listingscontributor", e.LaunchContributor = "launchcontributor", e.ContractsContributor = "contractscontributor", e.TransactionsContributor = "transactionscontributor", e.FinanceContributor = "financecontributor", e.WorkflowContributor = "workflowcontributor", e.Executive = "executive", e.SuperAdmin = "superadmin", e;
}({});
//#endregion
export { P as AgentRole, A as AgxAuth, f as AgxEnvironments, h as AuthContext, N as AuthorizedApiBase, F as StaffRole, m as isNonProductionEnvironment, p as resolveAgxEnvironment };

//# sourceMappingURL=index.js.map